export default () => {
	if ($.cookie('setloc') != undefined) {
		$('#ltime option[value=' + $.cookie('setloc') + ']').attr('selected', 'selected')
	} else {
		$('#ltime option[value=\'0\']').attr('selected', 'selected')
	}
	$('#ltime').bind('change', function () {
		chtime()
	})

	function chtime() {
		const sltime = parseInt($('#ltime :selected').val())
		$.cookie('setloc', $('#ltime :selected').val())
		$('.tvshow .list .time').each(function (i, elem) {
			const ntime = $(elem).attr('data-realtime').split(':')
			let outtime = parseInt(ntime[0]) + sltime
			if (outtime >= 24) {
				outtime = outtime - 24
			} else if (outtime < 0) {
				outtime = outtime + 24
			}
			$(elem).html(outtime + ':' + ntime[1])
		})
	}

	chtime()
}
